import createEditManageWorkOrderType from '../modals/createEditManageWorkOrderType/lan/es';
import deleteManageWorkOrderType from '../modals/deleteManageWorkOrderType/lan/es';

export default {
    manage_workOrderType_name: "Nombre",
    manage_workOrderType_form: "Formulario",
    manage_workOrderType_estimatedDuration: "Duración estimada",
    manage_workOrderType_description: "Descripción",
    manage_workOrderType_search_by_name_form_description: "Buscar por Nombre, Formulario o Descripción",
    ...createEditManageWorkOrderType,
    ...deleteManageWorkOrderType,
}